export const SELECTED = "selected";
export const SELECTED_ALL = "selected_all";